import React, { FC } from "react";
import { InfoBox, Icon, Tooltip } from "@skyportal/ui-kit";
import { InfoCardProps } from "./types";
import { RequestStatus } from "types/common.types";
import { capitalize } from "utils/helpers";

import styles from "./InfoCard.module.css";

const InfoCard: FC<InfoCardProps> = ({ title, value, icon, color, tooltip, "data-testid": dataTestId }) => {
  return (
    <InfoBox
      title={
        <div className={styles.titleWithTooltip}>
          <span>{title}</span>

          {tooltip && (
            <Tooltip title={<p>{tooltip}</p>} arrow placement="bottom">
              <div className={styles.tooltipIcon}>
                <Icon icon="info-filled" height={16} color={`pop${capitalize(color)}` as any} />
              </div>
            </Tooltip>
          )}
        </div>
      }
      contentText={value}
      icon={icon}
      color={color}
      requestStatus={RequestStatus.SUCCESS}
      width="23%"
      minWidth="300px"
      data-testid={dataTestId}
    />
  );
};

export default InfoCard;
